import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="address-mode"
export default class extends Controller {
  static values = {
    inputSelector: String,
    targetSelector: String,
    showWhen: String
  }

  static targets = ["companyName", "vatNumber"]

  connect() {
    this.update()
  }

  update() {
    const target = this.element.querySelector(this.targetSelectorValue) || document.querySelector(this.targetSelectorValue)
    if (!target) return

    const shouldShow = this.currentValue() === this.showWhenValue

    target.classList.toggle("hidden", !shouldShow)
    target.setAttribute("aria-hidden", (!shouldShow).toString())
    this.toggleTargetControls(target, !shouldShow)
  }

  currentValue() {
    const selector = this.inputSelectorValue
    if (!selector) return null

    const scope = this.element
    const checked = scope.querySelector(`${selector}:checked`) || document.querySelector(`${selector}:checked`)
    if (checked) return checked.value

    const input = scope.querySelector(selector) || document.querySelector(selector)
    return input && "value" in input ? input.value : null
  }

  toggleTargetControls(container, shouldDisable) {
    const controls = container.querySelectorAll("input, select, textarea, fieldset")

    controls.forEach((el) => {
      if (el.dataset.origDisabled == null) {
        el.dataset.origDisabled = el.disabled ? "true" : "false"
      }
      if (el.dataset.origRequired == null && "required" in el) {
        el.dataset.origRequired = el.required ? "true" : "false"
      }

      if (shouldDisable) {
        el.disabled = true
        if ("required" in el) el.required = false
        el.setAttribute("aria-disabled", "true")
      } else {
        el.disabled = el.dataset.origDisabled === "true"
        if ("required" in el && el.dataset.origRequired != null) {
          el.required = el.dataset.origRequired === "true"
        }
        el.removeAttribute("aria-disabled")
      }
    })
  }
}
